import { render } from "./ToggleSwitch.vue?vue&type=template&id=311c3b9c&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=311c3b9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-311c3b9c"

export default script